import React from 'react';
import FileUpload from '../components/FileUpload';

const FileUploadPage: React.FC = () => {
  return <FileUpload />;
};

export default FileUploadPage;